const Icon = () => {
return (
  <svg
    width={25}
    height={26}
    viewBox="0 0 25 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2:160)">
      <path
        d="M11.9673 2.99444C11.9536 4.09893 12.8379 5.00538 13.9424 5.01906C15.0469 5.03273 15.9533 4.14846 15.967 3.04398C15.9807 1.93949 15.0964 1.03304 13.9919 1.01936C12.8874 1.00568 11.981 1.88996 11.9673 2.99444Z"
        fill="#F5F1F8"
      />
      <path
        d="M11.862 11.5027C11.8483 12.6071 12.7326 13.5136 13.837 13.5273C14.9415 13.5409 15.848 12.6567 15.8616 11.5522C15.8753 10.4477 14.9911 9.54125 13.8866 9.52757C12.7821 9.51389 11.8756 10.3982 11.862 11.5027Z"
        fill="#F5F1F8"
      />
      <path
        d="M11.7566 20.0109C11.7429 21.1154 12.6272 22.0218 13.7317 22.0355C14.8362 22.0492 15.7426 21.1649 15.7563 20.0604C15.77 18.9559 14.8857 18.0495 13.7812 18.0358C12.6767 18.0221 11.7703 18.9064 11.7566 20.0109Z"
        fill="#F5F1F8"
      />
    </g>
    <defs>
      <clipPath id="clip0_2:160">
        <rect
          width={24}
          height={24}
          fill="white"
          transform="translate(24.5 1.14951) rotate(90.7095)"
        />
      </clipPath>
    </defs>
  </svg>
);
}
export {Icon}